var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM11 11l3.5 3.5",
    stroke: "#B3B3B3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var MemoSvgSearch = /*#__PURE__*/React.memo(SvgSearch);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxM0MxMC41Mzc2IDEzIDEzIDEwLjUzNzYgMTMgNy41QzEzIDQuNDYyNDMgMTAuNTM3NiAyIDcuNSAyQzQuNDYyNDMgMiAyIDQuNDYyNDMgMiA3LjVDMiAxMC41Mzc2IDQuNDYyNDMgMTMgNy41IDEzWiIgc3Ryb2tlPSIjQjNCM0IzIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0xMSAxMUwxNC41IDE0LjUiIHN0cm9rZT0iI0IzQjNCMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8L3N2Zz4K";
export { MemoSvgSearch as ReactComponent };